import React, { useEffect, useRef } from "react";

const RenderHtml = ({ content, descriptionBox = false,disabled=false,whiteBg=false, inptDec, customeHeight=false, inline = false }) => {
  const containerRef = useRef(null);
  const sanitizeHtmlContent = (rawContent) => {
    if (!rawContent || typeof rawContent !== "string") return rawContent || "";
    try {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = rawContent;
      tempDiv.querySelectorAll("style,script,noscript").forEach((el) => el.remove());
      return tempDiv.innerHTML;
    } catch (error) {
      return rawContent
        .replace(/<style[\s\S]*?<\/style>/gi, "")
        .replace(/<script[\s\S]*?<\/script>/gi, "")
        .replace(/<noscript[\s\S]*?<\/noscript>/gi, "");
    }
  };
  const sanitizedContent = sanitizeHtmlContent(content);
  const cntnt = inline ? (
    <span dangerouslySetInnerHTML={{ __html: sanitizedContent }}></span>
  ) : (
    <div dangerouslySetInnerHTML={{ __html: sanitizedContent }}></div>
  );
  
  useEffect(() => {
    const root = containerRef.current;
    if (!root) return;
    if (!inline) {
      root.style.display = "flow-root";
    }
    const applyCaptionStyles = (captionEl) => {
      if (!captionEl?.style) return;
      captionEl.style.display = "block";
      captionEl.style.fontSize = "13px";
      captionEl.style.lineHeight = "1.4";
      captionEl.style.color = "#1f2937";
      captionEl.style.fontWeight = "500";
      captionEl.style.background = "#f3f4f6";
      captionEl.style.borderRadius = "4px";
      captionEl.style.padding = "8px 12px";
      captionEl.style.marginTop = "8px";
      captionEl.style.textAlign = "left";
      captionEl.style.clear = "both";
      captionEl.style.opacity = "0.9";
      captionEl.style.pointerEvents = "none";
      captionEl.style.width = "100%";
      captionEl.style.boxSizing = "border-box";
    };
    root.querySelectorAll("img").forEach((img) => {
      img.style.maxWidth = "100%";
      img.style.height = "auto";
    });
    root
      .querySelectorAll(".inline-editor-image.position-left")
      .forEach((wrapper) => {
        wrapper.style.float = "left";
        wrapper.style.maxWidth = "50%";
        wrapper.style.width = "auto";
        wrapper.style.margin = "1em 1em 0 0";
        wrapper.style.display = "inline-block";
      });
    root
      .querySelectorAll(".inline-editor-image.position-right")
      .forEach((wrapper) => {
        wrapper.style.float = "right";
        wrapper.style.maxWidth = "50%";
        wrapper.style.width = "auto";
        wrapper.style.margin = "1em 0 0 1em";
        wrapper.style.display = "inline-block";
      });
    root
      .querySelectorAll(".inline-editor-image.position-center, .inline-editor-image.position-full")
      .forEach((wrapper) => {
        wrapper.style.float = "none";
        wrapper.style.display = "block";
        wrapper.style.margin = "1em auto";
        wrapper.style.maxWidth = "100%";
        wrapper.style.width = "auto";
      });
    root
      .querySelectorAll(".inline-image-caption")
      .forEach((captionEl) => applyCaptionStyles(captionEl));
    const imgs = root.querySelectorAll('img[showCaption="true"]');
    imgs.forEach((img) => {
      const wrapper = img.parentElement || root;
      if (wrapper.querySelector('.inline-image-caption')) return;
      const raw = img.getAttribute('caption');
      let captionText = '';
      if (raw) {
        try {
          const decodedRaw = raw.replace(/&quot;/g, '"');
          const obj = JSON.parse(decodedRaw);
          const stateStr = obj?.editorState;
          if (stateStr) {
            try {
              const decodedStateStr = stateStr.replace(/&quot;/g, '"');
              const state = JSON.parse(decodedStateStr);
              const texts = [];
              const walk = (node) => {
                if (!node) return;
                if (typeof node.text === 'string') texts.push(node.text);
                if (Array.isArray(node.children)) node.children.forEach(walk);
                if (node.root) walk(node.root);
              };
              walk(state);
              captionText = texts.join(' ').trim();
            } catch {}
          }
        } catch {}
      }
      if (!captionText) {
        const decodedParentHtml = (wrapper.innerHTML || '').replace(/&quot;/g, '"');
        const match = decodedParentHtml.match(/"text"\s*:\s*"([^"]+)"/);
        if (match && match[1]) {
          captionText = match[1].trim();
        }
      }
      if (!captionText) return;
      const cap = document.createElement('div');
      cap.className = 'inline-image-caption';
      cap.textContent = captionText;
      applyCaptionStyles(cap);
      wrapper.appendChild(cap);
    });
  }, [inline, sanitizedContent]);
  
  if (descriptionBox) {
    return (
      <div
        style={{
          width: "99%",
          padding: "8px",
          border: "1px solid #ddd",
          borderRadius: "4px",
          fontSize: "14px",
          // backgroundColor: whiteBg ? "#fff" : "#f5f5f5",
          cursor: "not-allowed",
          minHeight: "80px",
          backgroundColor: disabled ? "#f5f5f5" : "white",
        }}
      >
        <div className="editor-content" ref={containerRef}>
          {cntnt}
        </div>
      </div>
    );
  } else if (inptDec) {
    return (
      <div
        style={{
          fontSize: "13px",
          borderRadius: "5px",
          opacity: 0.7,
          width: "98%",
          border: "1px solid #00000036",
          padding: "5px 3px 0px 5px",
          height: customeHeight ? customeHeight :"19px",
          overflow:"hidden"
        }}
      >
        <div className="editor-content" ref={containerRef}>
          {cntnt}
        </div>
      </div>
    );
  } else {
    return (
      inline ? (
        <span className="editor-content editor-content-inline" style={{ display: "inline" }} ref={containerRef}>
          {cntnt}
        </span>
      ) : (
        <div className="editor-content" ref={containerRef}>{cntnt}</div>
      )
    );
  }
};

export const InputDescription = ({ content, customeHeight = "26px" }) => {
  return (
    <div
      style={{
        fontSize: "13px",
        borderRadius: "5px",
        opacity: 0.7,
        width: "98%",
        border: "1px solid #00000036",
        padding: "5px 3px 0px 5px",
        minHeight: customeHeight,
        overflow: "hidden"
      }}
    >
      <div className="editor-content" dangerouslySetInnerHTML={{ __html: content }}></div>
    </div>
  );
};

export default RenderHtml;
